import "./RentalOptionsPricing.module.css";
import Navbar from "@/reusable_sections/Header";
import RentalOptions from "./sections/RentalOptions";
import Inclusions from "./sections/Inclusions";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function RentalOptionsPricingPage() {
  return <div>
      <Navbar />
      <RentalOptions />
      <Inclusions />
      <Quote />
      <Footer />
    </div>;
}